// Scroll animations
      const obs = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("visible");
              obs.unobserve(e.target);
            }
          });
        },
        { threshold: 0.1 },
      );
      document.querySelectorAll(".fade-in").forEach((el) => obs.observe(el));

      // Nav shadow
      window.addEventListener("scroll", () => {
        document
          .getElementById("navWrap")
          .classList.toggle("scrolled", window.scrollY > 50);
      });

      // Tabs
      document.querySelectorAll(".tab-btn").forEach((btn) => {
        btn.addEventListener("click", () => {
          document
            .querySelectorAll(".tab-btn")
            .forEach((b) => b.classList.remove("active"));
          document
            .querySelectorAll(".tab-grid")
            .forEach((g) => g.classList.remove("active"));
          btn.classList.add("active");
          const target = document.querySelector(
            '.tab-grid[data-tab="' + btn.dataset.tab + '"]',
          );
          if (target) target.classList.add("active");
        });
      });

      // Marquee pause on hover
      const marquee = document.querySelector(".marquee-track");
      if (marquee) {
        marquee.addEventListener(
          "mouseenter",
          () => (marquee.style.animationPlayState = "paused"),
        );
        marquee.addEventListener(
          "mouseleave",
          () => (marquee.style.animationPlayState = "running"),
        );
      }